export const FixedWindowReference = ({reference,testIdPrefix='fixed-reference'}) => {
  if (!reference) return null;
  return <section className="fixed-performance-reference" data-testid={`${testIdPrefix}-panel`}>
    <h3 data-testid={`${testIdPrefix}-title`}>Supplied performance example</h3>
    <span className="reference-only" data-testid={`${testIdPrefix}-status`}>REFERENCE ONLY · SYSTEM NOT IDENTIFIED</span>
    <dl>{[
      ['size','Sample size',`${reference.width_inches}″ × ${reference.height_inches}″`],
      ['u-factor','U-factor',`${reference.u_factor.toFixed(6)} ${reference.u_factor_unit}`],
      ['shgc','SHGC',reference.shgc.toFixed(6)],
      ['vt','Visible transmittance',reference.visible_transmittance.toFixed(6)],
      ['cr','Condensation resistance',reference.condensation_resistance],
    ].map(([id,label,value])=><div key={id} data-testid={`${testIdPrefix}-${id}`}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
    <p data-testid={`${testIdPrefix}-settings`}>{reference.calculation_settings}</p>
    <p data-testid={`${testIdPrefix}-disclaimer`}>{reference.disclaimer}</p>
    <a data-testid={`${testIdPrefix}-source`} href={`${process.env.REACT_APP_BACKEND_URL}${reference.source_image}`} target="_blank" rel="noreferrer">View supplied screenshot ↗</a>
  </section>;
};